/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1SerievideoIdMutationResponse,
  DeleteApiV1SerievideoIdPathParams,
  DeleteApiV1SerievideoIdQueryParams,
  DeleteApiV1SerievideoId401,
  DeleteApiV1SerievideoId404,
  DeleteApiV1SerievideoId500,
} from "../../types/serieVideoRegistroController/DeleteApiV1SerievideoId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1SerievideoId } from "../../clients/serieVideoRegistroController/deleteApiV1SerievideoId.ts";

export const deleteApiV1SerievideoIdMutationKey = () =>
  [{ url: "/api/v1/serievideo/:id" }] as const;

export type DeleteApiV1SerievideoIdMutationKey = ReturnType<
  typeof deleteApiV1SerievideoIdMutationKey
>;

export function deleteApiV1SerievideoIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = deleteApiV1SerievideoIdMutationKey();
  return mutationOptions<
    DeleteApiV1SerievideoIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerievideoId401
      | DeleteApiV1SerievideoId404
      | DeleteApiV1SerievideoId500
    >,
    {
      id: DeleteApiV1SerievideoIdPathParams["id"];
      params?: DeleteApiV1SerievideoIdQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, params }) => {
      return deleteApiV1SerievideoId(id, params, config);
    },
  });
}

/**
 * @description Exclusão física do vídeo, suas traduções e visualizações. **(Requer Authorization para autenticação)**
 * @summary Excluir vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:id}
 */
export function useDeleteApiV1SerievideoId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1SerievideoIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1SerievideoId401
        | DeleteApiV1SerievideoId404
        | DeleteApiV1SerievideoId500
      >,
      {
        id: DeleteApiV1SerievideoIdPathParams["id"];
        params?: DeleteApiV1SerievideoIdQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiV1SerievideoIdMutationKey();

  const baseOptions = deleteApiV1SerievideoIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1SerievideoIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerievideoId401
      | DeleteApiV1SerievideoId404
      | DeleteApiV1SerievideoId500
    >,
    {
      id: DeleteApiV1SerievideoIdPathParams["id"];
      params?: DeleteApiV1SerievideoIdQueryParams;
    },
    TContext
  >;

  return useMutation<
    DeleteApiV1SerievideoIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerievideoId401
      | DeleteApiV1SerievideoId404
      | DeleteApiV1SerievideoId500
    >,
    {
      id: DeleteApiV1SerievideoIdPathParams["id"];
      params?: DeleteApiV1SerievideoIdQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1SerievideoIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SerievideoId401
      | DeleteApiV1SerievideoId404
      | DeleteApiV1SerievideoId500
    >,
    {
      id: DeleteApiV1SerievideoIdPathParams["id"];
      params?: DeleteApiV1SerievideoIdQueryParams;
    },
    TContext
  >;
}
